import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Calendar, Clock } from 'lucide-react';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const LiveUpdates = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUpdates();
    const interval = setInterval(fetchUpdates, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchUpdates = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/live-updates`);
      setUpdates(response.data);
    } catch (error) {
      console.error('Error fetching updates:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="live-updates-page">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[300px] mt-20" data-testid="live-updates-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-green-600"></div>
        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="w-3 h-3 rounded-full bg-white animate-pulse"></div>
              <h1 className="text-5xl md:text-6xl font-bold text-white">Live Updates</h1>
            </div>
            <p className="text-xl text-white/90">Real-time updates from ongoing events</p>
          </div>
        </div>
      </section>

      {/* Updates Timeline */}
      <section className="section-spacing" data-testid="updates-timeline">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20">
              <div className="inline-block w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-600">Loading updates...</p>
            </div>
          ) : updates.length > 0 ? (
            <div className="space-y-6">
              {updates.map((update, index) => (
                <div key={update.id} className="bg-white rounded-xl shadow-lg p-6 hover-lift border-l-4 border-orange-500" data-testid={`update-${index}`}>
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-green-600 flex items-center justify-center text-white font-bold">
                        <div className="w-3 h-3 rounded-full bg-white animate-pulse"></div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center space-x-2 text-orange-600 mb-2">
                        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                        <span className="text-xs font-semibold uppercase">Live</span>
                      </div>
                      <h3 className="text-xl font-bold text-gray-800 mb-2">{update.title}</h3>
                      <p className="text-gray-600 mb-4 leading-relaxed">{update.description}</p>
                      <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                        <div className="flex items-center">
                          <Calendar size={16} className="mr-2" />
                          {update.event_date}
                        </div>
                        <div className="flex items-center">
                          <Clock size={16} className="mr-2" />
                          {new Date(update.created_at).toLocaleTimeString()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="text-6xl mb-4">📰</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">No Live Updates</h3>
              <p className="text-gray-600">Check back soon for the latest event updates!</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LiveUpdates;